import { useEffect } from 'react';
import { useReservationFormMachines } from './ReservationFormMachinesContext';

function useDebugReservationMachines() {
  const { mainActor, fieldRefs } = useReservationFormMachines();

  useEffect(() => {
    const logMain = () => {
      const s = mainActor.getSnapshot();
      console.log('[reservationFormMain]', s.value, s.context);
    };

    const unsubMain = mainActor.subscribe((snapshot) => {
      console.log('[reservationFormMain]', snapshot.value, snapshot.context);
    });

    const childEntries = Object.entries(fieldRefs) as [
      keyof typeof fieldRefs,
      (typeof fieldRefs)[keyof typeof fieldRefs],
    ][];

    const unsubsChildren = childEntries.map(([name, ref]) =>
      ref.subscribe((snapshot) => {
        console.log(`[${String(name)}]`, snapshot.value, snapshot.context);
      }),
    );

    logMain();

    return () => {
      unsubMain.unsubscribe();
      unsubsChildren.forEach((u) => u.unsubscribe());
    };
  }, [mainActor, fieldRefs]);
}

export { useDebugReservationMachines };